<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :loading="loading"
    :search="search"
    :items-per-page="20"
  >
    <template v-slot:item.forgeID="{ item }">
      <ProjectNavigation :instance="item" />
    </template>
    <template v-slot:item.user.display_name="{ item }">
      {{ item.user.display_name }}
    </template>
    <template v-slot:item.tag.name="{ item }">
      <ProjectTagChip
        :tag="item.tag"
        :id="item.id"
        :tags="tags"
        :loading="loading"
      />
    </template>
  </v-data-table>
</template>

<script>
import ProjectTag from "../../models/ProjectTag";
import ProjectNavigation from "./ProjectNavigation";
import ProjectTagChip from "./ProjectTagChip";
export default {
  name: "ProjectsTable",
  components: { ProjectTagChip, ProjectNavigation },
  data() {
    return {
      tagLoading: true,
      headers: [
        { text: "ID", align: "left", sortable: true, value: "forgeID" },
        { text: "Title", sortable: true, value: "name" },
        { text: "Company", sortable: true, value: "company.name" },
        {
          text: "Technical Project Manager",
          sortable: true,
          align: "center",
          value: 'user.display_name'
        },
        {
          text: "Status",
          sortable: true,
          align: "center",
          value: "tag.name"
        }
      ]
    };
  },
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    search: {
      type: String,
      required: true,
      default: ""
    },
    items: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  computed: {
    tags() {
      return ProjectTag.all();
    }
  }
};
</script>
